import React from "react";

const StatCard = ({ icon: Icon, label, value, subtext, color }) => {
  return (
    <div className="stat-card">
      <div
        className="stat-icon"
        style={{ backgroundColor: `${color}20`, color }}
      >
        <Icon size={24} />
      </div>
      <div className="stat-content">
        <div className="stat-label">{label}</div>
        <div className="stat-value">{value !== undefined ? value : "0"}</div>
        {subtext && <div className="stat-subtext">{subtext}</div>}
      </div>
    </div>
  );
};

export default StatCard;
